// extracted by mini-css-extract-plugin
export var root = "ProductCollectionGrid-module--root--b222e";